import {routes} from './evento.routes';
import EventoListController from "./directory/directory.controller";
import EventoService from "./evento.service";
import EventoDetailsController from "./details/details.controller";
import EventoCreateEventoController from "./new/new.controller";

export default angular.module('app.evento', [])
  .config(routes)
  .controller('EventoListController', EventoListController)
  .service('EventoService', EventoService)
  .controller('EventoDetailsController', EventoDetailsController)
  .controller('EventoCreateEventoController', EventoCreateEventoController)
  .name;
